import { render } from "./BankUpdateRequestDetails.vue?vue&type=template&id=464a4792&scoped=true&ts=true"
import script from "./BankUpdateRequestDetails.vue?vue&type=script&lang=ts"
export * from "./BankUpdateRequestDetails.vue?vue&type=script&lang=ts"

import "./BankUpdateRequestDetails.vue?vue&type=style&index=0&id=464a4792&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-464a4792"]])

export default __exports__